import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function FeaturedArticles() {
  const featured = articles.slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              精品资讯
            </h2>
            <p className="mt-2 text-foreground-500 text-sm md:text-base">
              深度解读亚洲精品文化与趋势
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-background-100 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={`${article.title} - 亚洲精品资讯`}
                  title={`${article.title} - 亚洲精品 ${article.category}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500/90 text-white text-xs rounded-full whitespace-nowrap">
                  {article.category}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readTime}阅读</span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  {article.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-5">
          {articles.slice(3).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex gap-4 p-4 bg-background-100 rounded-xl transition-all duration-300 hover:bg-primary-50/50 cursor-pointer"
            >
              <div className="w-24 h-24 md:w-28 md:h-28 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={article.image}
                  alt={`${article.title} - 亚洲精品资讯`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 text-xs text-foreground-400 mb-1">
                  <span>{article.category}</span>
                  <span>·</span>
                  <span>{article.date}</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                  {article.readTime}阅读
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}